const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }

  if (Number(values.capacity <= 0)) {
    errors.capacity = 'Digite uma capacidade válida!';
  }
  return errors;
};

export default validate;
